module.exports = __webpack_public_path__ + "assets/img/3_1391_big.0665117f.jpg";